import { createContext, useContext, useEffect } from "react";

/**
 * Allows modal content to register a footer with the Modal shell so the footer
 * is rendered in a fixed bar at the bottom (outside the scroll area).
 * Modal reads footer from context; modal content uses useModalFooter(node).
 */
export const ModalFooterContext = createContext(null);

/**
 * Set the modal footer. Footer is shown in the Modal shell (fixed at bottom).
 * Clears footer on unmount.
 * @param {React.ReactNode} footer - Footer content (e.g. <WizardNavigation ... />)
 * @param {Array} deps - Optional dependency array; effect re-runs when these change so footer updates (e.g. [submitLabel, disabled])
 */
export function useModalFooter(footer, deps = []) {
  const value = useContext(ModalFooterContext);
  const setFooter = value?.[1];
  useEffect(() => {
    if (setFooter) setFooter(footer ?? null);
    return () => {
      if (setFooter) setFooter(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps intentionally control when to push latest footer
  }, [setFooter, ...deps]);
}
